import * as swcHelpers from '@swc/helpers';
import { priceVatCalc, calcPrice, DataLayer } from '@grandvisionhq/analytics';

const getVariantSpecification = (specificationName, variant)=>{
    var ref;
    return ((ref = variant.specifications.find((spec)=>spec.specificationAttribute === specificationName
    )) === null || ref === void 0 ? void 0 : ref.value.toString().toLowerCase()) || '';
};
const getJoinedValues = (values)=>{
    return (values === null || values === void 0 ? void 0 : values.join(', ').toLowerCase()) || '';
};
const getProductDetailEventTrackingSharedAttributes = ({ activeVariant , product , purchaseType , pricePerMonth , lineItemType  })=>{
    var ref, ref1, ref2, ref3;
    const { DataLayerTypes: { PurchaseType , Stock , BrandType , LineItemType  } ,  } = DataLayer;
    // metric140
    const originalPrice = activeVariant.price.originalPrice.amount;
    const discountedPrice = (ref = activeVariant.price.discountedPrice) === null || ref === void 0 ? void 0 : ref.price.amount;
    // metric142
    let metric142 = '';
    const vatRate = product === null || product === void 0 ? void 0 : (ref1 = product.taxCategory) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.rate) === null || ref2 === void 0 ? void 0 : ref2.amount;
    if (vatRate) {
        const { vatAmount  } = discountedPrice ? priceVatCalc(discountedPrice, vatRate) : priceVatCalc(originalPrice, vatRate);
        metric142 = calcPrice(vatAmount, false);
    }
    /*
   Note: Contact lenses are not yet migrated to V2
   Contact lenses subscription pricing
  */ const monthlyPriceOnSubscription = pricePerMonth && purchaseType === PurchaseType.CLBBSubscription ? pricePerMonth : undefined;
    // metric price
    const price = monthlyPriceOnSubscription || discountedPrice || originalPrice || undefined;
    // metric140
    const previousPrice = monthlyPriceOnSubscription || originalPrice || undefined;
    // metric141
    const discountedAmount = discountedPrice && originalPrice - discountedPrice || 0;
    // dimension190
    const erpId = getVariantSpecification('erpId', activeVariant);
    // dimension193
    let dimension193 = '';
    const exclusiveBrand = getVariantSpecification('exclusiveBrand', activeVariant);
    if (exclusiveBrand !== undefined) {
        dimension193 = exclusiveBrand ? BrandType.OwnBrand : BrandType.ExternalBrand;
    }
    // dimension194
    const isInStock = ((ref3 = activeVariant.stock) === null || ref3 === void 0 ? void 0 : ref3.stockCount) > 0;
    return {
        name: activeVariant.displayName,
        id: activeVariant.sku || '',
        price: calcPrice(price, false),
        dimension143: purchaseType,
        dimension144: lineItemType || LineItemType.Single,
        dimension145: 'true',
        dimension190: erpId,
        dimension193,
        dimension194: isInStock ? Stock.InStock : Stock.OutOfStock,
        metric140: calcPrice(previousPrice, false),
        metric141: calcPrice(discountedAmount, false),
        metric142
    };
};
const getAccessoriesEventAttributes = (sharedAttributes, masterSku, activeVariant)=>swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Accessories,
        brand: getVariantSpecification('brand', activeVariant),
        variant: getVariantSpecification('accessoryType', activeVariant),
        dimension16: getVariantSpecification('gender', activeVariant),
        dimension146: getVariantSpecification('material', activeVariant),
        dimension147: getVariantSpecification('accessoryColor', activeVariant),
        dimension140: masterSku
    })
;
const getSunglassesEventAttributes = (sharedAttributes, masterSku, activeVariant)=>{
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Sunglasses,
        brand: getVariantSpecification('brand', activeVariant),
        variant: getVariantSpecification('frameShape', activeVariant),
        dimension16: getVariantSpecification('gender', activeVariant),
        dimension140: masterSku,
        dimension146: getVariantSpecification('frameMaterial', activeVariant),
        dimension147: getVariantSpecification('frameColor', activeVariant),
        dimension191: getVariantSpecification('frameType', activeVariant),
        dimension192: getJoinedValues(activeVariant.faceShapes)
    });
};
const getFramesEventAttributes = (sharedAttributes, masterSku, activeVariant)=>{
    var ref, ref4;
    return swcHelpers.objectSpread({}, sharedAttributes, {
        category: DataLayer.DataLayerTypes.Category.Optical,
        brand: getVariantSpecification('brand', activeVariant),
        variant: getVariantSpecification('frameShape', activeVariant),
        dimension16: getVariantSpecification('gender', activeVariant),
        dimension140: masterSku,
        dimension146: (ref = getVariantSpecification('frameMaterial', activeVariant)) !== null && ref !== void 0 ? ref : '',
        dimension147: (ref4 = getVariantSpecification('frameColor', activeVariant)) !== null && ref4 !== void 0 ? ref4 : '',
        dimension191: getVariantSpecification('frameType', activeVariant),
        dimension192: getJoinedValues(activeVariant.faceShapes)
    });
};
const getProductDetailEventTrackingAttributes = (pdtp)=>{
    const { masterSku , activeVariant  } = pdtp;
    const sharedAttributes = getProductDetailEventTrackingSharedAttributes(pdtp);
    switch(activeVariant.variantType){
        case 'sunglasses':
            return getSunglassesEventAttributes(sharedAttributes, masterSku, activeVariant);
        case 'accessories':
            return getAccessoriesEventAttributes(sharedAttributes, masterSku, activeVariant);
        case 'frames':
            return getFramesEventAttributes(sharedAttributes, masterSku, activeVariant);
        default:
            /**
       * TODO: Add other product types after they have been migrated to PDP V2
       * Migration progress reference: https://confluence.grandvision.global/pages/viewpage.action?spaceKey=GV&title=PDP+v2+migration+status
       */ return undefined;
    }
};

export { getProductDetailEventTrackingAttributes };
//# sourceMappingURL=get-product-detail-event-tracking-attributes.js.map
